import { render, staticRenderFns } from "./projectListDialog.vue?vue&type=template&id=55829136&scoped=true"
import script from "./projectListDialog.vue?vue&type=script&lang=js"
export * from "./projectListDialog.vue?vue&type=script&lang=js"
import style0 from "./projectListDialog.vue?vue&type=style&index=0&id=55829136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55829136",
  null
  
)

export default component.exports